var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "sidebar-tool",
      class: { active: _vm.isMenuActive(), "mobile-sidebar": _vm.isMobile },
    },
    [
      _c(
        "div",
        {
          staticClass: "sidebar-content",
          on: {
            mouseenter: _vm.mouseEnterStart,
            mouseleave: _vm.mouseLeaveStart,
          },
        },
        [
          _vm.cloneItems.length > 0
            ? _c("div", { staticClass: "sidebar-menu" }, [
                _c(
                  "div",
                  { staticClass: "sidebar-menu-content" },
                  [
                    _vm._l(_vm.cloneItems, function (item) {
                      return [
                        _c(
                          "a-tooltip",
                          {
                            key: item.key,
                            attrs: {
                              title: item.label,
                              placement: "right",
                              overlayClassName: _vm.isMenuActive()
                                ? ""
                                : "hiddenToolTip",
                            },
                          },
                          [
                            item.route
                              ? _c(
                                  "router-link",
                                  {
                                    staticClass: "menu-item",
                                    attrs: { to: item.route },
                                  },
                                  [
                                    _c("SidebarChildItem", {
                                      attrs: {
                                        item: _vm.$_.merge({}, item, {
                                          label: _vm.formatMenuLabel(
                                            item.label
                                          ),
                                        }),
                                        isSelected: _vm.isSelected,
                                        isMenuActive: _vm.isMenuActive,
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _c("SidebarChildItem", {
                                  attrs: {
                                    item: _vm.$_.merge({}, item, {
                                      label: _vm.formatMenuLabel(item.label),
                                    }),
                                    isSelected: _vm.isSelected,
                                    isMenuActive: _vm.isMenuActive,
                                  },
                                  on: {
                                    selected: _vm.fnCallback,
                                    clicked: _vm.fnCallback,
                                  },
                                }),
                          ],
                          1
                        ),
                      ]
                    }),
                  ],
                  2
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.groupedItems, function (groupItem) {
            return _c(
              "div",
              { staticClass: "sidebar-grouped" },
              [
                _c(
                  "a-tooltip",
                  {
                    key: groupItem.name,
                    attrs: {
                      title: groupItem.name,
                      placement: "right",
                      overlayClassName: _vm.isMenuActive()
                        ? ""
                        : "hiddenToolTip",
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "sidebar-grouped-head",
                        on: {
                          click: function ($event) {
                            return _vm.toggleSubMenu(groupItem)
                          },
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "sidebar-grouped-head-title" },
                          [_vm._v(_vm._s(groupItem.name))]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "sidebar-grouped-head-collapse" },
                          [
                            _c("div", { staticClass: "material-icons" }, [
                              _vm._v(
                                _vm._s(
                                  groupItem.showMore
                                    ? "expand_less"
                                    : "expand_more"
                                )
                              ),
                            ]),
                          ]
                        ),
                      ]
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "sidebar-menu",
                    class: { closed: !groupItem.showMore },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "sidebar-menu-content" },
                      [
                        _vm._l(groupItem.items, function (item) {
                          return [
                            _c(
                              "a-tooltip",
                              {
                                key: item.key,
                                attrs: {
                                  title: item.label,
                                  placement: "right",
                                  overlayClassName: _vm.isMenuActive()
                                    ? ""
                                    : "hiddenToolTip",
                                },
                              },
                              [
                                item.route
                                  ? _c(
                                      "router-link",
                                      { attrs: { to: item.route } },
                                      [
                                        _c("SidebarChildItem", {
                                          attrs: {
                                            item: item,
                                            isSelected: _vm.isSelected,
                                            isMenuActive: _vm.isMenuActive,
                                          },
                                        }),
                                      ],
                                      1
                                    )
                                  : _c("SidebarChildItem", {
                                      attrs: {
                                        item: item,
                                        isSelected: _vm.isSelected,
                                        isMenuActive: _vm.isMenuActive,
                                      },
                                      on: { selected: _vm.fnCallback },
                                    }),
                              ],
                              1
                            ),
                          ]
                        }),
                      ],
                      2
                    ),
                  ]
                ),
              ],
              1
            )
          }),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "sidebar-tool-collapse", on: { click: _vm.toggle } },
        [
          _c("div", { staticClass: "information-text" }, [
            _vm._v(_vm._s(_vm.$t("message.showHide"))),
          ]),
          _vm._v(" "),
          _c("div", [
            _c("div", { staticClass: "material-icons" }, [
              _vm._v(
                _vm._s(_vm.isMenuActive() ? "chevron_left" : "chevron_right")
              ),
            ]),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }